export default "/images/vendor/@coreui/icons/svg/flag/cif-mv.svg?826558f9d5142271b04f435f5b21f9f6";